<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="halfTitlePage_02"><p class="halfTitlePageTitle"><span><img alt="logo" src="Images/halftitle.jpg"/></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743483629_halfTitlePage_02.vue?18bf7ef6